var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-card",
        { staticClass: "fish", staticStyle: { "max-width": "100%" } },
        [
          _c(
            "v-tabs",
            {
              attrs: { "slider-color": "primary" },
              model: {
                value: _vm.active,
                callback: function($$v) {
                  _vm.active = $$v
                },
                expression: "active"
              }
            },
            [
              _c("v-tabs-slider", { attrs: { color: "primary" } }),
              _c(
                "v-tab",
                {
                  staticStyle: { "font-size": "11px", height: "50px" },
                  attrs: { href: "#tab-1" }
                },
                [_vm._v("Registro Actividades")]
              ),
              _vm._l(3, function(i) {
                return _c(
                  "v-tab-item",
                  { key: i, attrs: { value: "tab-" + i } },
                  [
                    i === 1
                      ? _c(
                          "v-card",
                          { attrs: { flat: "" } },
                          [
                            _c(
                              "v-card-title",
                              {
                                staticStyle: {
                                  padding: "5px 5px 5px 20px",
                                  height: "55px"
                                }
                              },
                              [
                                _vm.vehiculoUnidad
                                  ? _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "font-size": "17px",
                                          "text-transform": "uppercase",
                                          "background-color":
                                            "rgb(0, 0, 0, 0.18)",
                                          padding: "5px"
                                        }
                                      },
                                      [_vm._v(_vm._s(_vm.vehiculoUnidad))]
                                    )
                                  : _vm._e(),
                                _vm.vehiculoUnidad
                                  ? _c(
                                      "v-btn",
                                      {
                                        staticStyle: {
                                          "font-size": "12px",
                                          background: "white",
                                          "margin-right": "0px"
                                        },
                                        attrs: { depressed: "", flat: "" },
                                        on: {
                                          click: function($event) {
                                            return _vm.handleVerDetalleClick()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n              Ver Detalle\n              "
                                        ),
                                        _c(
                                          "v-icon",
                                          { attrs: { right: "", dark: "" } },
                                          [_vm._v("keyboard_arrow_right")]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                !_vm.vehiculoTransmite &&
                                (_vm.mostrarFacturacion ||
                                  _vm.mostrarSolicitudes) &&
                                _vm.marcaBlanca.getSubDomain() == "gpschile"
                                  ? _c("ButtonCrearSolicitud")
                                  : _vm._e()
                              ],
                              1
                            ),
                            _c("v-divider"),
                            _c(
                              "v-card-actions",
                              {
                                staticClass: "grilla",
                                staticStyle: {
                                  "padding-top": "1px",
                                  "padding-bottom": "1px",
                                  "padding-right": "16px"
                                },
                                attrs: { id: "grillaId" }
                              },
                              [
                                _c("grid", {
                                  staticClass: "ag-theme-material",
                                  staticStyle: {
                                    width: "100%",
                                    height: "400px",
                                    "font-family": "'Asap', sans-serif"
                                  },
                                  attrs: {
                                    "data-testid": "test__unidad",
                                    gridOptions: _vm.gridOptions,
                                    getRowNodeId: _vm.getRowNodeId,
                                    "row-data": _vm.rowData,
                                    animateRows: true,
                                    deltaRowDataMode: true,
                                    "funcionalidad-id":
                                      _vm.funcionalidadActividades,
                                    immutableColumns: true
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "v-card-text",
                              {
                                staticStyle: {
                                  "text-align": "right",
                                  padding: "10px 10px 10px 5px"
                                }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "font-size": "13px",
                                      "padding-right": "10px"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "Mostrando " +
                                        _vm._s(_vm.cantidadActiviadades) +
                                        " actividades"
                                    )
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              })
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }